// BE `CidrMatcher.IsValid` aynası: tek IPv4/IPv6 adresi veya CIDR bloğu.
// Prefix IPv4'te 0-32, IPv6'da 0-128 aralığında olmalı.
const IPV4_GROUPS = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/;

function isValidIpv4(value: string): boolean {
  const match = IPV4_GROUPS.exec(value);
  if (!match) return false;
  return match.slice(1).every((octet) => Number(octet) <= 255);
}

function isValidIpv6(value: string): boolean {
  if (value.includes(':::')) return false;
  const halves = value.split('::');
  if (halves.length > 2) return false;
  const toGroups = (half: string | undefined) => (!half ? [] : half.split(':'));
  const groups = [...toGroups(halves[0]), ...(halves.length === 2 ? toGroups(halves[1]) : [])];
  let count = groups.length;
  for (let i = 0; i < groups.length; i++) {
    const group = groups[i] ?? '';
    // Son grupta gömülü IPv4'e izin ver (ör. ::ffff:192.168.1.1) — 2 grup sayılır.
    if (i === groups.length - 1 && group.includes('.')) {
      if (!isValidIpv4(group)) return false;
      count += 1;
      continue;
    }
    if (!/^[0-9a-f]{1,4}$/i.test(group)) return false;
  }
  return halves.length === 2 ? count < 8 : count === 8;
}

export function isValidCidr(value: string | null | undefined): boolean {
  if (!value) return false;
  const v = value.trim();
  if (!v) return false;
  const slash = v.indexOf('/');
  const address = slash === -1 ? v : v.slice(0, slash);
  const prefix = slash === -1 ? null : v.slice(slash + 1);
  const v4 = isValidIpv4(address);
  const v6 = !v4 && address.includes(':') && isValidIpv6(address);
  if (!v4 && !v6) return false;
  if (prefix === null) return true;
  if (!/^\d{1,3}$/.test(prefix)) return false;
  return Number(prefix) <= (v4 ? 32 : 128);
}
